/* eslint-disable import/prefer-default-export */
export const loginSuccess = 'AAD_LOGIN_SUCCESS';
export const storeToken = 'STORE_TOKEN';
export const getToken = 'GET_TOKEN';
export const updateAccountData = 'UPDATE_ACCOUNT_DATA';
export const setToLimitedViewer = 'SET_TO_LIMITED_VIEWER';
